import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M7 4a12.25 12.25 0 0 0 0 16","key":"svg-0"}],["path",{"d":"M17 4a12.25 12.25 0 0 1 0 16","key":"svg-1"}]]

const IconParentheses = createReactComponent('outline', 'parentheses', 'Parentheses', __iconNode);

export default IconParentheses;